import Calendar from "@toast-ui/react-calendar";
import React from "react";
import Layout_Dashboard from "../Layout_Dashboard/Layout_Dashboard";
import moment from "moment";
import "tui-calendar/dist/tui-calendar.css";
import "tui-date-picker/dist/tui-date-picker.css";
import "tui-time-picker/dist/tui-time-picker.css";
import { Button, Menu, MenuItem } from "@material-ui/core";
import classes from "./SchedulerWebView.module.css";
import {
  ArrowBackIosOutlined,
  ArrowForwardIosOutlined,
} from "@material-ui/icons";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { SCHEDULER } from "../../utils/url-builder";
import BaseService from "../../store/services/base.service";
import { BASE_URL } from "../../config";
import { getKneuraId, getUserId } from "../../utils/authentication-access";

class SchedulerWebView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      today: new Date().toDateString(),
      displayDate: new Date().toDateString(),
      schedules: [],
      classes: [],
      viewAnchorEl: null,
      viewType: "Month View",
    };
    this.calendar = React.createRef();
  }

  componentDidMount() {
    this.getSchedules();
    this.getClasses();
  }

  getClasses = () => {
    let classes = JSON.parse(localStorage.getItem("classes"));
    classes = classes.map((item) => {
      return {
        id: item.kneuraId,
        name: item.name,
        bgColor: "#9e5fff",
        borderColor: "#9e5fff",
      };
    });
    this.setState({ classes });
  };

  getSchedules = async () => {
    try {
      let class_ids = JSON.parse(localStorage.getItem("classes"));
      class_ids = class_ids.map((item) => item.kneuraId);
      class_ids = JSON.stringify(class_ids);
      const url = SCHEDULER.fetch();
      const res = await new BaseService().makeGetRequestGeneric(url, {
        class_ids,
      });
      const schedules = res.schedules.map((schedule) => {
        return {
          id: schedule.id,
          calendarId: schedule.classId,
          title: schedule.title,
          location: schedule.description,
          body: schedule.description,
          category: "time",
          start: moment(schedule.startDate).toISOString(),
          end: moment(schedule.endDate).toISOString(),
          isVisible: true,
        };
      });
      this.setState({ schedules });
    } catch (error) {
      console.log({ error });
    }
  };

  createSchedule = async (schedule) => {
    try {
      const url = SCHEDULER.create();
      const data = {
        classId: schedule.calendarId,
        title: schedule.title,
        description: schedule.location,
        startDate: new Date(schedule.start),
        endDate: new Date(schedule.end),
        creatorId: getKneuraId(),
      };
      const res = await new BaseService().makePostRequestGeneric(url, data);
      await this.getSchedules();
    } catch (error) {
      console.log({ error });
    }
  };

  updateSchedule = async (data) => {
    try {
      const url = SCHEDULER.update();
      const formData = {
        id: data.schedule.id,
        classId: data.changes.calendarId || data.schedule.calendarId,
        title: data.changes.title || data.schedule.title,
        description: data.changes.location || data.schedule.location,
        startDate: data.changes.start
          ? new Date(data.changes.start)
          : new Date(data.schedule.start),
        endDate: data.changes.end
          ? new Date(data.changes.end)
          : new Date(data.schedule.end),
      };
      await new BaseService().makePostRequestGeneric(url, formData);
      await this.getSchedules();
    } catch (error) {
      console.log({ error });
    }
  };

  deleteSchedule = async (data) => {
    try {
      const url = SCHEDULER.delete(data.schedule.id);
      await new BaseService().makePostRequestGeneric(url, {});
      await this.getSchedules();
    } catch (error) {
      console.log({ error });
    }
  };

  render() {
    const { displayDate } = this.state;
    const myTheme = {},
      today = this.state.today;
    return (
      <Layout_Dashboard
      classname={"Scheduler"}
      hideClassSwitcher={true}
      >
        {/* <h1>Scheduler</h1> */}

        <div
          id="calendar"
          style={{ height: "100%", width: "100%", background: "white" }}
        >
          <div
            style={{
              height: "6%",
              // width: "100%",
              display: "grid",
              gridTemplateColumns: "13% 74% 13%",
              padding: "1%",
              alignContent: "center",
            }}
          >
            <Button
              variant="outlined"
              className={classes.DefaultBtn}
              // startIcon={<PlusIcon />}
              onClick={(event) => {
                // this.calendar.current.calendarInst._openCreationPopup();
              }}
              style={{ visibility: "hidden" }}
            >
              +<span style={{ paddingLeft: "0.5vw" }}>Create Event</span>
            </Button>
            <div style={{ textAlign: "center", alignSelf: "center" }}>
              <ArrowBackIosOutlined
                style={{ fontSize: "1.1rem" }}
                onClick={(e) => {
                  this.setState({
                    displayDate: moment(displayDate).subtract(1, "month"),
                  });
                  this.calendar.current.calendarInst.prev();
                }}
              />
              <span style={{ padding: "1%", fontSize: "22px" }}>
                {moment(displayDate).format("MMMM YYYY")}
              </span>
              <ArrowForwardIosOutlined
                style={{ fontSize: "1.1rem" }}
                onClick={(e) => {
                  this.setState({
                    displayDate: moment(displayDate).add(1, "month"),
                  });
                  this.calendar.current.calendarInst.next();
                }}
              />
              <Button
                variant="outlined"
                style={{ marginLeft: "2%", borderRadius: "25px" }}
                onClick={(e) => {
                  this.calendar.current.calendarInst.today();
                }}
              >
                Today
              </Button>
            </div>
            <Button
              style={{
                boxShadow: "none",
                marginTop: "1vh",
              }}
              variant="outlined"
              endIcon={<ArrowDropDownIcon />}
              onClick={(e) => this.setState({ viewAnchorEl: e.target })}
            >
              {this.state.viewType}
            </Button>
          </div>
          <Calendar
            ref={this.calendar}
            usageStatistics={false}
            height="90%"
            calendars={this.state.classes || [{ id: "0", name: "Test" }]}
            disableDblClick={true}
            disableClick={false}
            isReadOnly={true}
            month={{
              startDayOfWeek: 0,
              moreLayerSize: { width: "100%", height: "100%" },
            }}
            schedules={
              this.state.schedules || [
                {
                  id: "1",
                  calendarId: "0",
                  title: "TOAST UI Calendar Study",
                  category: "time",
                  dueDateClass: "",
                  start: today.toISOString(),
                  end: moment(today).add(3, "hours").toISOString(),
                },
                {
                  id: "2",
                  calendarId: "0",
                  title: "Practice",
                  category: "milestone",
                  dueDateClass: "",
                  start: moment(today).add(1, "hours").toISOString(),
                  end: moment(today).subtract(-3, "hours").toISOString(),
                  isReadOnly: true,
                },
                {
                  id: "3",
                  calendarId: "0",
                  title: "FE Workshop",
                  category: "allday",
                  dueDateClass: "",
                  start: moment(today).subtract(2, "hours").toISOString(),
                  end: moment(today).subtract(1, "hours").toISOString(),
                  isReadOnly: true,
                },
              ]
            }
            // scheduleView={true}
            taskView={true}
            template={{
              milestone(schedule) {
                return `<span style="color:#fff;background-color: ${
                  "white" || schedule.bgColor
                };">${schedule.title}</span>`;
              },
              milestoneTitle() {
                return "Milestone";
              },
              allday(schedule) {
                return `${schedule.title}<i class="fa fa-refresh"></i>`;
              },
              alldayTitle() {
                return "All Day";
              },
              locationPlaceholder() {
                return "Description";
              },
              titlePlaceholder() {
                return "Subject";
              },
            }}
            onBeforeCreateSchedule={this.createSchedule}
            onBeforeUpdateSchedule={this.updateSchedule}
            onBeforeDeleteSchedule={this.deleteSchedule}
            theme={myTheme}
            timezones={[
              {
                timezoneOffset: 330,
                displayLabel: "GMT+5:30",
                tooltip: "India",
              },
            ]}
            useDetailPopup
            useCreationPopup
            view={"month"}
            week={{
              showTimezoneCollapseButton: true,
              timezonesCollapsed: true,
            }}
          />
        </div>
        <Menu
          id="sorter-menu"
          anchorEl={this.state.viewAnchorEl}
          keepMounted
          open={Boolean(this.state.viewAnchorEl)}
          onClose={(e) => this.setState({ viewAnchorEl: null })}
        >
          <MenuItem
            onClick={() => {
              this.setState({ viewType: "Month View", viewAnchorEl: null });
              this.calendar.current.calendarInst.changeView("month", true);
            }}
          >
            Month View
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              this.setState({
                viewType: "Week View",
                viewAnchorEl: null,
              });
              this.calendar.current.calendarInst.changeView("week", true);
            }}
          >
            Week View
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              this.setState({
                viewType: "Day View",
                viewAnchorEl: null,
              });
              this.calendar.current.calendarInst.changeView("day", true);
            }}
          >
            Day View
          </MenuItem>
        </Menu>
      </Layout_Dashboard>
    );
  }
}

export default SchedulerWebView;
